import { useTranslation } from 'react-i18next';

export default function Features() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-scales-3-line',
      title: t('features.price_title'),
      desc: t('features.price_desc'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('features.qc_title'),
      desc: t('features.qc_desc'),
    },
    {
      icon: 'ri-global-line',
      title: t('features.shipping_title'),
      desc: t('features.shipping_desc'),
    },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight flex-shrink-0">
            {t('features.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
            {t('features.subtitle')}
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-2xl p-6 md:p-8 transition-all duration-300 hover:scale-[1.01]"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-6">
                <i className={`${feat.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}